/**
 * Checks if an unknown is an error, and if it is not, wraps it in an new Error before returning it.
 * @param exception The maybe error
 * @returns An error instance
 */
export default function unknownToError(exception: unknown): Error {
	return exception instanceof Error ? exception : new Error(`${exception}`);
}
